import { Slack } from 'lucide-react';
import { FormattedMessage } from 'react-intl';

import { ViteEnv } from '@/env';

import { Button } from '../ui/button';

const handleInstall = (event: React.MouseEvent<HTMLButtonElement>) => {
  event.currentTarget.blur();
  window.open(`${ViteEnv.VITE_BACKEND_URL}/annie/slack/install`, '_blank');
};

interface Props {
  variant: 'main' | 'chat';
}

export const AddToSlackButton = ({ variant }: Props): JSX.Element => {
  if (variant === 'chat') {
    return (
      <Button
        variant="ghost"
        onClick={handleInstall}
        className="h-4 border rounded-full border-gray-400 flex items-center gap-1 overflow-hidden p-2 box-content hover:bg-background/50"
      >
        <div className="flex items-center justify-center">
          <Slack className="h-4 w-4" />
        </div>
        <span>
          <FormattedMessage id="configuration.slackApp.button.label" />
        </span>
      </Button>
    );
  }

  return (
    <Button variant="main" className="text-white" onClick={handleInstall}>
      <Slack size={24} className="inline mr-2" />
      <span className="inline-block min-w-[100px] text-center">
        <FormattedMessage id="configuration.slackApp.button.label" />
      </span>
    </Button>
  );
};
